import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/* eslint-disable @repo/internal/react/no-class-components */
import React from 'react';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);
  var _super = _createSuper(ErrorBoundary);
  function ErrorBoundary(props) {
    var _this;
    _classCallCheck(this, ErrorBoundary);
    _this = _super.call(this, props);
    _this.state = {
      hasError: false
    };
    return _this;
  }
  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      var analyticsEvent = this.props.createAnalyticsEvent({
        action: 'handled',
        actionSubject: 'error',
        actionSubjectId: 'remoteModuleErrorBoundary',
        attributes: {
          error: error === null || error === void 0 ? void 0 : error.message,
          errorInfo: errorInfo,
          dimensions: this.props.remotePlugin.dimensions,
          plugin: this.props.remotePlugin.constructor.name
        }
      });
      analyticsEvent.fire(this.props.analyticsChannel);
      if (this.props.onError) {
        this.props.onError(error, errorInfo);
      }
      this.setState({
        hasError: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        return this.props.fallback ? /*#__PURE__*/React.createElement(React.Fragment, null, this.props.fallback) : null;
      }
      return this.props.children;
    }
  }]);
  return ErrorBoundary;
}(React.Component);
export default withAnalyticsEvents()(ErrorBoundary);